import React, { useState, useEffect, useRef } from "react";
import { SetHeading } from "../../context/NavbarContext";
import { Breadcrumb, Button, Drawer } from "antd";
import { DoubleRightOutlined, DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import { debounce } from "@mui/material";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { toast } from "react-toastify";
import i18next from "i18next";
import SelectBox from "../../components/CustomWidgets/SelectBox";
import moment from "moment";
import { checkPermission } from "../../Utils/permissionHelper";
import AddCustomerModal from "../../modals/AddCustomerModal";
// import ImportCustomers from "./ImportCustomers";
import ExportCasInOutReportModal from "../SessionHistory/ExportCasInOutReportModal";
import InventoryValidationTable from "./InventoryValidationTable";
import dayjs from "dayjs";
import DateFilter from "../../components/ui/DateFilter";

const InventoryValidation = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector((state) => state?.login?.user?.result?.company_id);
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);
  const allStores = useSelector((state) => state?.storeReducer?.selectedStore?.is_select_all_store);

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(10);
  const [currentOffset, setCurrentOffset] = useState(0);
  const [query, setQuery] = useState("");
  const [totalCount, setTotalCount] = useState(0);

    const today = dayjs();
    const formatToday = today.format("YYYY-MM-DD");
    const startofMonth = today.startOf("month").format("YYYY-MM-DD");
    
    const [startDate, setStartDate] = useState(startofMonth);
    const [endDate, setEndDate] = useState(formatToday);
    const [selectedRange, setSelectedRange] = useState("thisMonth"); // Matched AntD/DateFilter naming standard

  // Drawer state
  const [visible, setVisible] = useState(false);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [drawerItems, setDrawerItems] = useState([]);
  const [drawerRecord, setDrawerRecord] = useState(null);
  const [drawerLimit, setDrawerLimit] = useState(5);
  const [drawerOffset, setDrawerOffset] = useState(0);
  const [drawerTotal, setDrawerTotal] = useState(0);
  const navigate = useNavigate();

  // Other state
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isOpenImportCustomer, setIsOpenImportCustomer] = useState(false);
  const [openAddCustomer, setOpenAddCustomer] = useState(false);
  const printRef = useRef();

  // ─── Fetch main table data ───────────────────────────────────────────────────
const fetchInventoryStockVerification = async (
  limit = currentLimit,
  offset = currentOffset,
  start,
  end,
  value = ''
) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post(
       URLS.GET_INVENTORY_STOCK_VALIDATION,
      { company_id, user_id, limit, offset, search: value ,
         start_date: start || startDate, // 🔥 Connect start range
      end_date: end || endDate,     // 🔥 Connect end range
      }  // ← search included
    );
    const result = response?.data?.result;
    if (result?.status_code === 200 || result?.status === "success") {
      setTableData(result?.data || result?.records || []);
      setTotalCount(result?.total_count || result?.count || 0);
    } else {
      toast.error(result?.status || t("Failed to fetch inventory data"));
    }
  } catch (err) {
    toast.error(t("Error fetching inventory verification data"));
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    if (company_id && user_id) {
      fetchInventoryStockVerification(currentLimit, currentOffset, startDate, endDate);
    }
  }, [company_id, user_id, currentLimit, currentOffset, startDate, endDate]);

  // ─── Fetch drawer items ──────────────────────────────────────────────────────
  const fetchInventoryItems = async (record, limit = drawerLimit, offset = drawerOffset) => {
    setDrawerLoading(true);
    try {
      const payload = {
        in_stock_ver_id:record?.id,
        limit,
        offset,
      };
      const response = await axiosInstance.post(
        URLS.GET_INVENTORY_STOCK_VALIDATION_ITEMS,
        payload
      );
      const result = response?.data?.result;
      if (result?.status_code === 200 || result?.status === "success") {
        setDrawerItems(result?.items);
        setDrawerTotal(record?.no_of_items);
      } else {
        toast.error(result?.status || t("Failed to fetch items"));
      }
    } catch (error) {
      console.error("fetchInventoryItems error:", error);
      toast.error(t("Error fetching inventory items"));
    } finally {
      setDrawerLoading(false);
    }
  };


  // ─── Drawer open/close ───────────────────────────────────────────────────────
  const showDrawer = (record) => {
    setDrawerRecord(record);
    setDrawerOffset(0);
    setVisible(true);
    fetchInventoryItems(record, drawerLimit, 0);
  };

  const onClose = () => {
    setVisible(false);
    setDrawerRecord(null);
    setDrawerItems([]);
    setDrawerOffset(0);
  };

  // ─── Debounced search ────────────────────────────────────────────────────────
// const debouncedSearch = debounce((value) => {
//   setCurrentOffset(0);
//   fetchInventoryStockVerification(currentLimit, 0);
// }, 500);

 const debouncedSearch = useRef(
  debounce((value, start, end) => {
    fetchInventoryStockVerification(10, 0, start, end, value);
  }, 700)
).current;

  // ─── Print ───────────────────────────────────────────────────────────────────

  // ─── Helpers ─────────────────────────────────────────────────────────────────
  const getCurrentDate = () => moment().format("YYYY-MM-DD");

  const thStyle = {
    border: "1px solid #ccc",
    padding: "8px",
    background: "#f5f5f5",
    textAlign: "left",
  };
  const tdStyle = {
    border: "1px solid #ccc",
    padding: "8px",
  };

  // ─── Drawer pagination ────────────────────────────────────────────────────────
  const handleDrawerPageChange = (newOffset) => {
    setDrawerOffset(newOffset);
    fetchInventoryItems(drawerRecord, drawerLimit, newOffset);
  };

 
  // ─── Drawer item columns ──────────────────────────────────────────────────────
  // Adjust column keys to match your actual API response fields
  const drawerColumns = [
    { key: "product_name", label: t("Product Name") },
    { key: "barcode", label: t("Barcode") },
    { key: "system_qty", label: t("Expected Qty") },
    { key: "actual_qty", label: t("Actual Qty") },
    { key: "difference_qty", label: t("Difference") },
    { key: "reason", label: t("Reason") },
    { key: "notes", label: t("Note") },
  ];
const handleExport = async (type = "excel") => {
  const payload = {
    company_id,
    user_id,
    in_stock_ver_id: drawerRecord?.id,
    lang: i18next.language === "ar" ? "ar_001" : "en_US",
  };

  try {
    const response = await axiosInstance.post(
      type === "pdf"
        ? "/Store/2/GetInventoryStockVerificationReportPDF"
        : URLS.GET_INVENTORY_STOCK_VALIDATION_EXCEL,
      payload
    );

    if (response?.data?.result?.status_code === 200) {
      downloadFile(response?.data?.result?.file_base64);
    } else {
      toast.error(response?.data?.result?.status || t("Export failed"));
    }
  } catch (error) {
    console.error(error);
    toast.error(t("Something went wrong while exporting"));
  }
};

const downloadFile = (base64Data) => {
  try {
    if (
      !base64Data ||
      typeof base64Data !== "string" ||
      base64Data.trim() === ""
    ) {
      toast.error("No valid file data available");
      return;
    }

    let cleanBase64 = base64Data
      .trim()
      .replace(/^data:[\w/+.-]+;base64,/, "")
      .replace(/^["']|["']$/g, "")
      .replace(/\s/g, "");

    // Fix missing padding
    const padLength = 4 - (cleanBase64.length % 4);
    if (padLength < 4) {
      cleanBase64 += "=".repeat(padLength);
    }

    const binaryString = atob(cleanBase64);
    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const header = new Uint8Array(bytes.buffer, 0, 8);

    let mimeType = "application/octet-stream";
    let fileExtension = "bin";

    // PDF
    if (
      header[0] === 0x25 &&
      header[1] === 0x50 &&
      header[2] === 0x44 &&
      header[3] === 0x46
    ) {
      mimeType = "application/pdf";
      fileExtension = "pdf";
    }

    // XLSX
    else if (header[0] === 0x50 && header[1] === 0x4b) {
      mimeType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      fileExtension = "xlsx";
    }

    // XLS
    else if (
      header[0] === 0xd0 &&
      header[1] === 0xcf &&
      header[2] === 0x11 &&
      header[3] === 0xe0
    ) {
      mimeType = "application/vnd.ms-excel";
      fileExtension = "xls";
    }

    // CSV
    else {
      try {
        const headerText = new TextDecoder().decode(header);
        if (headerText.includes(",")) {
          mimeType = "text/csv";
          fileExtension = "csv";
        }
      } catch (e) {}
    }

    const blob = new Blob([bytes], { type: mimeType });

    const timestamp = new Date()
      .toISOString()
      .replace(/[:.]/g, "-")
      .replace("T", "_")
      .slice(0, 19);

    const filename = `inventory_verification_report_${timestamp}.${fileExtension}`;

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;

    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }, 100);
  } catch (error) {
    console.error("File download failed:", error);
    toast.error(error?.message || "Download failed");
  }
};
  
  return (
    <>
      <div className="flex w-full flex-col overflow-y-auto bg-[#F6F7F9] pb-2 md:h-full">
        <SetHeading value="Inventory Verification" />
        <div className="custom-scrollbar ms-1 flex-grow overflow-y-auto overflow-hidden sm:ms-3">

          {/* ── Top bar ── */}
          <div className="me-1 mt-4 flex flex-col gap-3 sm:me-3 md:me-8 md:flex-row md:items-start md:justify-between">
            <div className="flex w-full flex-col gap-2 md:w-auto md:flex-row items-end">
              <SearchBox
                value={query}
                searchResult={(values) => {
                  setQuery(values);
                  debouncedSearch(values,startDate, endDate);
                }}
                placeholder={t("Search")}
              />
 <DateFilter
                    setSelectedRange={setSelectedRange}
                    selectedRange={selectedRange}
                    SubmitFilter={(start, end) => {
                      setStartDate(start);
                      setEndDate(end);
                      setCurrentLimit(10);
                      setCurrentOffset(0);
                      // Triggering via state dependencies in useEffect
                    }}
                  />
            </div>
            {/* <div className="flex w-full gap-2 md:w-auto">
                <button
                            className="mt-1 flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white sm:w-48 md:mt-2"
                            onClick={() => handleExport()}
                          >
                            <DownloadOutlined
                              style={{ fontSize: "1.5em", MozMarginStart: -10 }}
                            />
              
                            <span>{t("Download in Excel")}</span>
                          </button>
            </div> */}
          </div>

          {/* ── Table ── */}
          {loading ? (
            <ShimmerLoader />
          ) : (
             <div className="mt-3">
                           <InventoryValidationTable
  additionalData={tableData}
  totalCount={totalCount}                    // ← pass it down
  pagination={({ limit, offset }) => {
    setCurrentLimit(limit);
    setCurrentOffset(offset);
  }}
  showDrawer={showDrawer}
/>


                        </div>
      
          )}
        </div>

      </div>

      {/* ── Drawer ── */}
      <Drawer
        title={
          <div>
            <div className="font-semibold text-base">
              {t("Verification Report")}
            </div>
            {drawerRecord && (
              <div className="text-sm text-gray-600 mt-1 font-normal">
                {drawerRecord.create_date && (
                  <div className="ml-1">
                   {t("Create Date")}: {drawerRecord.create_date}
                  </div>
                )}
               {drawerRecord.user && (<>
                  <div className="ml-1">
                   {t("User")}: {drawerRecord.user}
                  </div>
                  <div className="ml-1">
                   {t("Email")}: {drawerRecord.email}
                  </div>
                  <div className="ml-1">
                   {t("Phone")}: {drawerRecord.phone}
                  </div>
                </>)}
              </div>
            )}
          </div>
        }
        placement="right"
        width={typeof window !== "undefined" && window.innerWidth < 768 ? "95%" : 750}
        onClose={onClose}
        open={visible}
      >
        {drawerLoading ? (
          <div className="flex items-center justify-center h-40">
            <span className="text-gray-600">{t("Loading items...")}</span>
          </div>
        ) : (
         <div>
          {/* Items cards */}
{drawerItems.length > 0 ? (
  <>
<div className="flex gap-2 mb-5 -mt-5 justify-end flex-wrap">
  <button
    className="mt-1 flex h-10 items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white px-4"
    onClick={() => handleExport("excel")}
  >
    <DownloadOutlined style={{ fontSize: "1.5em" }} />
    <span>{t("Download Excel")}</span>
  </button>

  <button
    className="mt-1 flex h-10 items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white px-4"
    onClick={() => handleExport("pdf")}
  >
    <DownloadOutlined style={{ fontSize: "1.5em" }} />
    <span>{t("Download PDF")}</span>
  </button>
</div>
    <div>
      {drawerItems.map((item, index) => {
        const diff = Number(item.actual_qty) - Number(item.system_qty);
        console.log("diff==>",diff);
        
        const diffColor =
          diff < 0 ? "text-rose-600" : diff > 0 ? "text-green-600" : "text-gray-600";
        const diffPrefix = diff > 0 ? "+" : "";

        return (
          <div
            key={index}
            className="flex flex-col border rounded-lg bg-white p-3 mb-2 shadow-sm"
          >
            {/* Top row: icon + product name + barcode */}
            <div className="flex items-center gap-3">
             
              <div className="flex flex-col flex-1 min-w-0">
                <p className="font-semibold text-sm leading-tight text-gray-800 truncate">
                  {item.product_name ?? "—"}
                </p>
                <p className="text-xs text-gray-600 mt-0.5 font-mono">
                  {item.barcode ?? "—"}
                </p>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-100 my-2.5" />

            {/* Qty chips */}
            <div className="flex gap-2">
              <div className="flex flex-col items-center flex-1 bg-gray-50 rounded-lg py-1.5 px-2">
                <span className="text-[11px] text-gray-600 mb-0.5 whitespace-nowrap">{t("Expected Qty")}</span>
                <span className="text-sm font-semibold text-gray-700">{item.system_qty ?? "—"}</span>
              </div>
              <div className="flex flex-col items-center flex-1 bg-gray-50 rounded-lg py-1.5 px-2">
                <span className="text-[11px] text-gray-600 mb-0.5 whitespace-nowrap">{t("Actual Qty")}</span>
                <span className="text-sm font-semibold text-gray-700">{item.actual_qty ?? "—"}</span>
              </div>
              <div className="flex flex-col items-center flex-1 bg-gray-50 rounded-lg py-1.5 px-2">
                <span className="text-[11px] text-gray-600 mb-0.5">{t("Difference")}</span>
                <span className={`text-sm font-semibold text-re ${diffColor}`}>
                  {item.difference_qty != null ? `${diffPrefix}${item.difference_qty}` : "—"}
                </span>
              </div>
            </div>

            {/* Reason + Note */}
            <div className="flex gap-3 mt-2 text-xs text-gray-500">
              <div className="flex-1">
                <span className="text-gray-600">{t("Reason")}: </span>
                <span className="text-gray-700 font-medium">{t(item.reason) || "-"}</span>
              </div>
              <div className="flex-1 text-right">
                <span className="text-gray-600">{t("Note")}: </span>
                <span className="text-gray-700 font-medium">{item.notes || "-"}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>

    {/* Drawer pagination */}
    {drawerTotal > drawerLimit && (
      <div className="flex items-center justify-between px-1 pt-3">
        <span className="text-sm text-gray-500">
          {t("Showing")} {drawerOffset + 1}–{Math.min(drawerOffset + drawerLimit, drawerTotal)} {t("of")} {drawerTotal}
        </span>
        <div className="flex gap-2">
          <button
            disabled={drawerOffset === 0}
            onClick={() => handleDrawerPageChange(Math.max(0, drawerOffset - drawerLimit))}
            className="px-3 py-1 text-sm rounded border disabled:opacity-40 hover:bg-gray-50"
          >
            {t("Prev")}
          </button>
          <button
            disabled={drawerOffset + drawerLimit >= drawerTotal}
            onClick={() => handleDrawerPageChange(drawerOffset + drawerLimit)}
            className="px-3 py-1 text-sm rounded border disabled:opacity-40 hover:bg-gray-50"
          >
            {t("Next")}
          </button>
        </div>
      </div>
    )}
  </>
) : (
  <p className="text-gray-600 text-center py-10">
    {t("No items found for this verification")}
  </p>
)}
         </div>
        )}
      </Drawer>
    </>
  );
};

export default InventoryValidation;